import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { NotificationPanelService } from '@core/services';
import { SecurityStatus } from '@shared/enums/security-status';
import { NotificationPanelResponse } from '@shared/models/notification-panel/notification-panel-response';
import { NotificationPanelSecurity } from '@shared/models/notification-panel/notification-panel-security';
import { TaxResultSessionService } from '../../services/tax-result-session.service';

@Component({
  standalone: false,
  selector: 'gstar-notification-panel-item',
  templateUrl: './notification-panel-item.component.html',
  styleUrls: ['./notification-panel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationPanelItemComponent {
  private readonly router = inject(Router);
  private readonly notificationPanelService = inject(NotificationPanelService);
  private readonly taxResultSessionService = inject(TaxResultSessionService);

  @Input() notification!: NotificationPanelSecurity;
  @Input() body!: string;

  @Output() closeDrawer: EventEmitter<NotificationPanelResponse> =
    new EventEmitter();

  destroyRef = inject(DestroyRef);

  notificationClickHandler(_event: Event): void {
    if (this.notification.securityStatus === SecurityStatus.PendingApproval) {
      this.pendingApprovalHandler();
    } else {
      this.approveHandler();
    }
  }

  private pendingApprovalHandler(): void {
    this.closeDrawer.emit();
    this.taxResultSessionService.selectSecuritiesIdsAndUpdate([
      this.notification.securityId,
    ]);
    this.router.navigate(['tax-results/edit']);
  }

  private approveHandler(): void {
    this.notificationPanelService
      .notifyApprovedSecurity([this.notification.securityId])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.closeDrawer.emit();
        this.router.navigate([
          `portfolio/${this.notification.securityId}/details`,
        ]);
      });
  }
}
